/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./MpptAnalysis.vue?vue&type=template&id=871ce24c&"
import script from "./MpptAnalysis.vue?vue&type=script&lang=js&"
export * from "./MpptAnalysis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports